import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';

const API = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8001/api' 
  : '/api';

function SupportTicketPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    subject: '',
    initial_message: '',
    priority: 'normal'
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/support/tickets`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setSuccess(true);
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.detail || 'Destek talebi oluşturulamadı'));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <Navbar />
      
      <div className="max-w-2xl mx-auto px-4 py-8 mt-20">
        <div className="bg-gray-800 rounded-xl p-8 border border-gray-700">
          <h1 className="text-3xl font-bold text-white mb-2">📩 Destek Talebi Oluştur</h1>
          <p className="text-gray-400 mb-6">Sorunlarınız veya sorularınız için destek talebi oluşturun</p>

          {success ? (
            <div className="bg-green-900 border border-green-700 text-green-300 px-6 py-4 rounded-lg text-center">
              <div className="text-4xl mb-2">✅</div>
              <div className="text-lg font-bold mb-1">Talebiniz Alındı!</div>
              <div className="text-sm">En kısa sürede size dönüş yapılacaktır.</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Priority */}
              <div>
                <label className="block text-gray-300 font-semibold mb-2">Öncelik</label>
                <select
                  value={formData.priority}
                  onChange={(e) => setFormData({...formData, priority: e.target.value})}
                  className="w-full bg-gray-700 text-white px-4 py-3 rounded-lg border border-gray-600 focus:border-blue-500 focus:outline-none"
                  required
                >
                  <option value="low">🟢 Düşük</option>
                  <option value="normal">🟡 Normal</option>
                  <option value="high">🔴 Yüksek</option>
                </select>
              </div>

              {/* Subject */}
              <div>
                <label className="block text-gray-300 font-semibold mb-2">Konu</label>
                <input
                  type="text"
                  value={formData.subject}
                  onChange={(e) => setFormData({...formData, subject: e.target.value})}
                  className="w-full bg-gray-700 text-white px-4 py-3 rounded-lg border border-gray-600 focus:border-blue-500 focus:outline-none"
                  placeholder="Örn: Para yatırma sorunu"
                  required
                />
              </div>

              {/* Message */}
              <div>
                <label className="block text-gray-300 font-semibold mb-2">Mesajınız</label>
                <textarea
                  value={formData.initial_message}
                  onChange={(e) => setFormData({...formData, initial_message: e.target.value})}
                  className="w-full bg-gray-700 text-white px-4 py-3 rounded-lg border border-gray-600 focus:border-blue-500 focus:outline-none"
                  rows="6"
                  placeholder="Lütfen sorunuzu veya talebinizi detaylı bir şekilde açıklayın..."
                  required
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-lg transition-colors disabled:bg-gray-600 disabled:cursor-not-allowed"
              >
                {loading ? 'Gönderiliyor...' : '📤 Talebi Gönder'}
              </button>

              <button
                type="button"
                onClick={() => navigate(-1)}
                className="w-full bg-gray-700 hover:bg-gray-600 text-white font-bold py-3 rounded-lg transition-colors"
              >
                ← Geri Dön
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default SupportTicketPage;
